<div class="container_filter">
  <div class="header">
    <div class="title-description">
      <h2 class="filter-title">
        {{ "agent.filter.title" | translate }}
      </h2>
      <p class="filter-description">
        {{ "filter.description" | translate }}
      </p>
    </div>
    <button class="close" (click)="close()">
      <img src="assets/icones/close.svg" alt="" />
    </button>
  </div>

  <div class="content">
    <div class="selection">
      <div class="import-and-selected">
        <ng-container *ngIf="agentFilters?.filters?.length > 0">
          <button class="select-saved-filter" [matMenuTriggerFor]="menu">
            <img src="assets/icones/import-filter.svg" alt="" />
            <small>{{ "filter.import" | translate }}</small>
          </button>
          <mat-menu #menu="matMenu" class="import-menu" >
            <div class="filter_btn"
              *ngFor="let filter of agentFilters?.filters || []"

            >
              <span (click)="setFilter(filter)"
              >{{ filter.name }}</span>
              <button (click)="deleteFilter(filter)" >
                <img src="assets/icones/delete_btn.svg" alt="">
              </button>
            </div>
          </mat-menu>
        </ng-container>
        <div class="applied-filters-count" (click)="clearFilters()">
          <span class="count">{{ getFiltersCount() }}</span>
          <span>{{ "filter.applied" | translate }}</span>
          <img src="assets/icones/clear-filter.svg" alt="" />
        </div>
      </div>
      <div
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'agent_info'"
        (click)="selectedGroup = 'agent_info'"
      >
        <div class="group-title">
          <img src="assets/icones/info.svg" alt="" />
          <h3>{{ "agent.filter.groups.agent_info" | translate }}</h3>
        </div>
        <div class="filters">
          <div class="filter" *ngIf="filter.agentsInfoFilter.first_name">
            <span>
              {{ "agent.filter.fields.first_name" | translate }} :
              {{ filter.agentsInfoFilter.first_name }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.agentsInfoFilter.first_name = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.agentsInfoFilter.last_name">
            <span>
              {{ "agent.filter.fields.last_name" | translate }} :
              {{ filter.agentsInfoFilter.last_name }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.agentsInfoFilter.last_name = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.agentsInfoFilter.email">
            <span>
              {{ "agent.filter.fields.email" | translate }} :
              {{ filter.agentsInfoFilter.email }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.agentsInfoFilter.email = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.agentsInfoFilter.phone != null">
            <span>
              {{ "agent.filter.fields.phone" | translate }} :
              {{ filter.agentsInfoFilter.phone }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.agentsInfoFilter.phone = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.agentsInfoFilter.country != null">
            <span>
              {{ "agent.filter.fields.country" | translate }} :
              {{ filter.agentsInfoFilter.country }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.agentsInfoFilter.country = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.agentsInfoFilter.address != null">
            <span>
              {{ "agent.filter.fields.address" | translate }} :
              {{ filter.agentsInfoFilter.address }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.agentsInfoFilter.address = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.agentsInfoFilter.vat != null">
            <span>
              {{ "agent.filter.fields.vat" | translate }} :
              {{ filter.agentsInfoFilter.vat }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.agentsInfoFilter.vat = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.agentsInfoFilter.billing_address != null">
            <span>
              {{ "agent.filter.fields.billing_address" | translate }} :
              {{ filter.agentsInfoFilter.billing_address }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.agentsInfoFilter.billing_address = undefined
              "
            />
          </div>
        </div>
      </div>
      <div
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'extra_info'"
        (click)="selectedGroup = 'extra_info'"
      >
        <div class="group-title">
          <img src="assets/icones/organize.svg" alt="" />
          <h3>{{ "agent.filter.groups.extra_info" | translate }}</h3>
        </div>
        <div class="filters">
          <div class="filter" *ngIf="filter.extraInfoFilter.catalog_name">
            <span>
              {{ "agent.filter.fields.catalog_name" | translate }} :
              {{ filter.extraInfoFilter.catalog_name }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.extraInfoFilter.catalog_name = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.extraInfoFilter.tags.length > 0">
            <span>
              {{ "agent.filter.fields.tag_name" | translate }} :
              {{ getTags() }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.extraInfoFilter.tags = []
              "
            />
          </div>
          <div class="filter" *ngIf="filter.extraInfoFilter.location_name">
            <span>
              {{ "agent.filter.fields.location_name" | translate }} :
              {{ filter.extraInfoFilter.location_name }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.extraInfoFilter.location_name = undefined
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="
              filter.extraInfoFilter.nbr_orders_min != null ||
              filter.extraInfoFilter.nbr_orders_max != null
            "
          >
            <span>
              {{ "agent.filter.fields.nbr_orders" | translate }} :
              <ng-container *ngIf="filter.extraInfoFilter.nbr_orders_min != null">
                {{ "common.from" | translate }}
                {{ filter.extraInfoFilter.nbr_orders_min }}
              </ng-container>
              <ng-container *ngIf="filter.extraInfoFilter.nbr_orders_max != null">
                {{ "common.to" | translate }}
                {{ filter.extraInfoFilter.nbr_orders_max }}
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.extraInfoFilter.nbr_orders_min = undefined;
                filter.extraInfoFilter.nbr_orders_max = undefined
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="
              filter.extraInfoFilter.nbr_locations_min != null ||
              filter.extraInfoFilter.nbr_locations_max != null
            "
          >
            <span>
              {{ "agent.filter.fields.nbr_locations" | translate }} :
              <ng-container *ngIf="filter.extraInfoFilter.nbr_locations_min != null">
                {{ "common.from" | translate }}
                {{ filter.extraInfoFilter.nbr_locations_min }}
              </ng-container>
              <ng-container *ngIf="filter.extraInfoFilter.nbr_locations_max != null">
                {{ "common.to" | translate }}
                {{ filter.extraInfoFilter.nbr_locations_max }}
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.extraInfoFilter.nbr_locations_min = undefined;
                filter.extraInfoFilter.nbr_locations_max = undefined
              "
            />
          </div>
        </div>
      </div>
    </div>
    <div class="form">
      <ng-container *ngIf="selectedGroup === 'agent_info'">
        <div class="form-title">
          <img src="assets/icones/info.svg" alt="" />
          <h3>{{ "agent.filter.groups." + selectedGroup | translate }}</h3>
        </div>

        <div class="inputs">
          <div class="inputs-pair">
            <div class="field">
              <label for="first_name">{{
                "agent.filter.fields.first_name" | translate
              }}</label>
              <input
                id="first_name"
                type="text"
                [(ngModel)]="filter.agentsInfoFilter.first_name"
                [placeholder]="'agent.filter.fields.first_name' | translate"
              />
            </div>
            <div class="field">
              <label for="last_name">{{
                "agent.filter.fields.last_name" | translate
              }}</label>
              <input
                id="last_name"
                type="text"
                [(ngModel)]="filter.agentsInfoFilter.last_name"
                [placeholder]="'agent.filter.fields.last_name' | translate"
              />
            </div>
          </div>

          <div class="inputs-pair">
            <div class="field">
              <label for="email">{{
                "agent.filter.fields.email" | translate
              }}</label>
              <input
                id="email"
                type="text"
                [(ngModel)]="filter.agentsInfoFilter.email"
                [placeholder]="'agent.filter.fields.email' | translate"
              />
            </div>
            <div class="field">
              <label for="phone">{{
                "agent.filter.fields.phone" | translate
              }}</label>
              <input
                id="phone"
                type="text"
                [(ngModel)]="filter.agentsInfoFilter.phone"
                [placeholder]="'agent.filter.fields.phone' | translate"
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="country">{{
                "agent.filter.fields.country" | translate
              }}</label>
              <select [(ngModel)]="filter.agentsInfoFilter.country">
                <option [ngValue]="undefined" disabled>
                  {{ "agent.filter.fields.country" | translate }}
                </option>
                <option *ngFor="let country of countries$ | async" [ngValue]="country.name">{{ country.name  | translate}}</option>
              </select>
            </div>
            <div class="field">
              <label for="address">{{
                "agent.filter.fields.address" | translate
              }}</label>
              <input
                id="address"
                type="text"
                [(ngModel)]="filter.agentsInfoFilter.address"
                [placeholder]="'agent.filter.fields.address' | translate"
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="vat">{{
                "agent.filter.fields.vat" | translate
              }}</label>
              <input
                id="vat"
                type="text"
                [(ngModel)]="filter.agentsInfoFilter.vat"
                [placeholder]="'agent.filter.fields.vat' | translate"
              />
            </div>
            <div class="field">
              <label for="billing_address">{{
                "agent.filter.fields.billing_address" | translate
              }}</label>
              <input
                id="billing_address"
                type="text"
                [(ngModel)]="filter.agentsInfoFilter.billing_address"
                [placeholder]="'agent.filter.fields.billing_address' | translate"
              />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedGroup === 'extra_info'">
        <div class="form-title">
          <img src="assets/icones/organize.svg" alt="" />
          <h3>{{ "agent.filter.groups." + selectedGroup | translate }}</h3>
        </div>
        <div class="inputs">
          <div class="inputs-pair">
            <div class="field">
              <label for="catalog_name">{{
                "agent.filter.fields.catalog_name" | translate
              }}</label>
              <input
                id="catalog_name"
                type="text"
                [(ngModel)]="filter.extraInfoFilter.catalog_name"
                [placeholder]="'agent.filter.fields.catalog_name' | translate"
              />
            </div>
            <div class="field">
              <label for="tag_name">{{
                "agent.filter.fields.tag_name" | translate
              }}</label>
              <mat-chip-list #chipList>
                <mat-chip
                  *ngFor="let tag of filter.extraInfoFilter.tags"
                  [selectable]="true"
                  [removable]="true"
                  (removed)="removeTag(tag)"
                >
                  {{ tag }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input
                  [placeholder]="'agent.filter.fields.tag_name' | translate"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addTag($event)"
                />
              </mat-chip-list>
            </div>
          </div>
          <div class="field">
            <label for="location_name">{{
              "agent.filter.fields.location_name" | translate
            }}</label>
            <input
              id="location_name"
              type="text"
              [(ngModel)]="filter.extraInfoFilter.location_name"
              [placeholder]="'agent.filter.fields.location_name' | translate"
            />
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="nbr_orders_min">{{
                "agent.filter.fields.nbr_orders_min" | translate
              }}</label>
              <input
                id="nbr_orders_min"
                type="number"
                min="0"
                [max]="filter.extraInfoFilter.nbr_orders_max || 1"
                [(ngModel)]="filter.extraInfoFilter.nbr_orders_min"
                [placeholder]="'agent.filter.fields.nbr_orders_min' | translate"
              />
            </div>
            <div class="field">
              <label for="nbr_orders_max">{{
                "agent.filter.fields.nbr_orders_max" | translate
              }}</label>
              <input
                id="nbr_orders_max"
                type="number"
                [min]="filter.extraInfoFilter.nbr_orders_min || 0"
                [(ngModel)]="filter.extraInfoFilter.nbr_orders_max"
                [placeholder]="'agent.filter.fields.nbr_orders_max' | translate"
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="nbr_locations_min">{{
                "agent.filter.fields.nbr_locations_min" | translate
              }}</label>
              <input
                id="nbr_locations_min"
                type="number"
                min="0"
                [max]="filter.extraInfoFilter.nbr_locations_max || 1"
                [(ngModel)]="filter.extraInfoFilter.nbr_locations_min"
                [placeholder]="'agent.filter.fields.nbr_locations_min' | translate"
              />
            </div>
            <div class="field">
              <label for="nbr_locations_max">{{
                "agent.filter.fields.nbr_locations_max" | translate
              }}</label>
              <input
                id="nbr_locations_max"
                type="number"
                [min]="filter.extraInfoFilter.nbr_locations_min || 0"
                [(ngModel)]="filter.extraInfoFilter.nbr_locations_max"
                [placeholder]="'agent.filter.fields.nbr_locations_max' | translate"
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="nbr_catalogs_min">{{
                "agent.filter.fields.nbr_catalogs_min" | translate
              }}</label>
              <input
                id="nbr_catalogs_min"
                type="number"
                min="0"
                [max]="filter.extraInfoFilter.nbr_catalogs_max || 1"
                [(ngModel)]="filter.extraInfoFilter.nbr_catalogs_min"
                [placeholder]="'agent.filter.fields.nbr_catalogs_min' | translate"
              />
            </div>
            <div class="field">
              <label for="nbr_catalogs_max">{{
                "agent.filter.fields.nbr_catalogs_max" | translate
              }}</label>
              <input
                id="nbr_catalogs_max"
                type="number"
                [min]="filter.extraInfoFilter.nbr_catalogs_min || 0"
                [(ngModel)]="filter.extraInfoFilter.nbr_catalogs_max"
                [placeholder]="'agent.filter.fields.nbr_catalogs_max' | translate"
              />
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="footer submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
        <span>{{"common.cancel"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
    </button>
    <div class="save-apply">
      <div class="save-filter-form" *ngIf="toggleSaveFilterForm && getFiltersCount() > 0">
        <div class="label-action">
          <label for="filter_name">{{
            "filter.filter_name" | translate
          }}</label>
          <div class="actions">
            <button class="cancel-btn" (click)="toggleSaveFilter()">{{ "common.cancel" | translate }}</button>
            <button class="save-btn" (click)="save()">
              {{ "common.save" | translate | uppercase }}
            </button>
          </div>
        </div>
        <input
          id="filter_name"
          type="text"
          class="filter-name-input"
          [placeholder]="'filter.filter_name' | translate"
          [(ngModel)]="filterName"
          [formControl]="filterNameControl"
        />
        <span class="error_ms" *ngIf="filterNameControl?.touched && filterNameControl?.errors">
          {{ "common.required_field" | translate }}
        </span>
      </div>
      <button
        class="save save_filter"
        [disabled]="getFiltersCount() <= 0" *ngIf="!toggleSaveFilterForm && !data"
        (click)="toggleSaveFilter()"
      >
        <img src="assets/icones/save-filter.svg" alt="" />
        <small>{{ "filter.save" | translate }}</small>
      </button>
      <button class="save_btn_pop_up blue_btn" (click)="apply()">
        <small>{{ "filter.apply" | translate | uppercase }}</small>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
</div>
